/* src/app/components/doc-viewer-new/doc-viewer-right-panel/doc-viewer-coding-tab/built-in-coding-section/built-in-coding-section.component.scss */
.info-icon {
  --fa-primary-color: #5a5a5a;
  --fa-secondary-color: #797979;
}
:host-context(.dark-theme) .info-icon {
  --fa-primary-color: #fff;
  --fa-secondary-color: #828282;
}
/*# sourceMappingURL=built-in-coding-section.component.css.map */
